export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const splashImage = require("../assets/backimage_splash.png")
export const splashLogo = require("../assets/imagebutton_logo.png")
export const noInternet = require('../assets/no-internet.png')